/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Seg_Study_TInputs */

const en_funnel_ob_seg_study_t = /** @type {(inputs: Funnel_Ob_Seg_Study_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Study & research`)
};

const es_funnel_ob_seg_study_t = /** @type {(inputs: Funnel_Ob_Seg_Study_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estudio e investigación`)
};

/**
* | output |
* | --- |
* | "Study & research" |
*
* @param {Funnel_Ob_Seg_Study_TInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_seg_study_t = /** @type {((inputs?: Funnel_Ob_Seg_Study_TInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Seg_Study_TInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_seg_study_t(inputs)
	return en_funnel_ob_seg_study_t(inputs)
});